import { CrudOp, projectManagementAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { OperatorView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const { evaluate } = authHelperCreator(projectManagementAuthScope);
  return project != null && evaluate(CrudOp.READ, project);
};

export const operatorViewKey = "app/project/:projectId/:subprojectId";
export const operatorViewModule: ViewModule = {
  viewKey: operatorViewKey,
  viewEl: <OperatorView/>,
  isAuthorized,
  translations,
};
